<template>
    <div
    v-if="title != undefined"
    class="title-box">
        <h1>{{title.topic}}</h1>

        <el-link
        v-if="title.more != undefined"
        :href="title.more.url"
        target="_lank"
        :underline="false">{{title.more.name}}</el-link>
    </div>
</template>

<script>
export default {
    name: 'Title',
    props: ['title']
}
</script>

<style scoped>
.title-box {
    display: flex;
    justify-content: space-between;
    border-bottom: dodgerblue solid 1px;
    margin: 20px 0 10px;
}

.title-box h1 {
    font-size: 20px;
    font-weight: bold;
    color: #111;
    position: relative;
    padding-left: 20px;
}

.title-box h1::before {
    content: '';
    width: 4px;
    height: 24px;
    background: dodgerblue;
    border-radius: 10px;
    position: absolute;
    top: calc(50% - 12px);
    left: 0;
}

.title-box .el-link span {
    font-size: 14px;
    font-weight: normal;
    color: #555;
}

.title-box .el-link span:hover {
    color: rgb(1, 5, 8);
}

.right-box .title-box {
    border-bottom: #ccc solid 1px;
}

.right-box .title-box h1 {
    color: #555;
}

.right-box .title-box h1::before {
    background: #dcdfe6;
}

.right-box .el-checkbox__label {
    padding-left: 4px;
}

@media(max-width: 1100px) {
    .title-box h1 {
        font-size: 16px;
    }

    .title-box .el-link {
        font-size: 12px;
    }
}
</style>
